module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Thin.efbf869.eot";